module.exports = __webpack_public_path__ + "/images/ico-nav-carriage.1865c5a.svg";